export const LimitTariffsFromOperator = 15;
export const LimitOperatorsList = 8;
export const LimitPlansBTableContainer = 15;
export const LIMITREVIEWTEXT = 150;
export const LIMITREVIEWSLENGTH = 3;
